<template>
  <div
    class="modal fade"
    id="modal-announcement"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content ">
        <div class="modal-header">
          <h5 class="modal-title">Systems Notification</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true" class="zmdi zmdi-close"></span>
          </button>
        </div>
        <div class="modal-body">
          <div
            v-for="(ad, aindex) in adInformation"
            :key="ad.anncmnt_id"
            class=""
          >
            <div v-if="showIndex === aindex">
              <div
                class="px-0 row col-12 col-sm-12 d-flex justify-content-between mx-0 "
              >
                <div class="px-0 col-6 col-sm-6 d-flex align-items-center">
                  <h4 class="  font-weight-bold  capitalize mb-0 ">
                    {{ ad.anncmnt_type }}
                  </h4>
                </div>
                <div class=" col-6 col-sm-6 d-flex justify-content-end px-0">
                  <button
                    type="button"
                    class="btn btn-outline-light"
                    @click="changeShowIndex(-1)"
                    :disabled="showIndex === 0"
                  >
                    <i class=" fas fa-chevron-left"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-light"
                    @click="changeShowIndex(1)"
                    :disabled="showIndex === adInformation.length - 1"
                  >
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>
              <div
                :class="getContentBg"
                class="  d-flex  justify-content-center row  px-0 mx-0 col-12 col-sm-12"
              >
                <div
                  class="modal-tall px-3 py-4 col-12 row col-sm-12 d-flex align-items-start "
                >
                  <div class="row col-sm-12 d-flex justify-content-center ">
                    <div
                      v-if="
                        ad.anncmnt_type === 'maintenance' ||
                          ad.anncmnt_type === 'general'
                      "
                      :class="getBackground"
                      class=" d-flex justify-content-center align-items-center rounded-circle"
                    >
                      <img
                        v-if="ad.anncmnt_type === 'maintenance'"
                        class="maintenance-size"
                        src="../assets/img/maintenance.png"
                        alt=""
                      />
                      <img
                        class="maintenance-size"
                        v-if="ad.anncmnt_type === 'general'"
                        src="../assets/img/ad.png"
                        alt=""
                      />
                    </div>
                  </div>

                  <div
                    class="col-sm-11 justify-content-start"
                    v-if="ad.anncmnt_type === 'maintenance'"
                  >
                    <div class="notice-title font-weight-bold">
                      {{
                        $t(
                          "the-system-maintenance-will-be-held-in-order-to-provide-the-best-user-experience-for-you-thank-you"
                        )
                      }}
                    </div>
                    <div class="notice-subtitle font-weight-bold mt-2">
                      {{ $t("start-time") }}: {{ ad.start }}
                    </div>
                    <div class="notice-subtitle font-weight-bold">
                      {{ $t("end-time") }}: {{ ad.end }}
                    </div>
                  </div>
                  <div
                    v-else
                    :class="
                      ad.anncmnt_type === 'activity'
                        ? 'd-flex justify-content-center'
                        : ''
                    "
                    class="col-sm-12 justify-content-start my-2 pb-4 notice-height image-container"
                  >
                    <div v-html="ad.anncmnt_content"></div>
                  </div>
                  <!-- <div class="d-flex justify-content-center col-12">
                    <h4 class="font-weight-bold mt-3  ">
                      {{ ad.anncmnt_content }}
                    </h4>
                  </div>

                  <h5 class="font-weight-bold">
                    {{ ad.start }} ~ {{ ad.end }}
                  </h5> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="form-check form-check-inline m-0 pr-2">
            <input
              type="checkbox"
              class="form-check-input"
              id="exampleCheck1"
              v-model="userCheckMaintenance"
            />
            <label class="form-check-label" for="exampleCheck1"
              >Don't show again</label
            >
          </div>
          <button
            type="button"
            class="btn btn-primary btn-rounded"
            @click="closeModal()"
          >
            Noted
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { ApiGetMaintenance } from "../http/apis/maintenance.js";
import dayjs from "dayjs";
export default {
  data() {
    return {
      userCheckMaintenance: false,
      show: false,
      adInformation: [],
      showIndex: 0,
    };
  },
  mounted() {
    this.getMaintenanceInfo();
  },
  computed: {
    getBackground() {
      if (this.adInformation[this.showIndex].anncmnt_type === "general") {
        return "notice-bg ";
      } else {
        return "maintenance-bg";
      }
    },
    getContentBg() {
      if (this.adInformation[this.showIndex].anncmnt_type === "general") {
        return "notice-content ";
      } else {
        return "maintenance-content";
      }
    },
  },
  methods: {
    async getMaintenanceInfo() {
      // 如果時間超過則把這個localstore 清除
      this.adInformation = [];
      const todayTimestamp = Math.floor(Date.now() / 1000);
      console.log(todayTimestamp);
      let result = await ApiGetMaintenance.get();
      console.log(result);
      if (result.status === "success") {
        result.record.forEach((element) => {
          if (element.display_flag === "true") {
            this.show = true;
          }

          let startTime = Number(element.start_date + "000");
          let endTime = Number(element.end_date + "000");
          element.start = dayjs(startTime).format("YYYY/MM/DD HH:mm");
          element.end = dayjs(endTime).format("YYYY/MM/DD HH:mm");
        });
        console.log(result.record);
        this.adInformation = result.record;
      }
      if (localStorage.getItem("stop-show-maintenance") === "true") {
      } else if (result.record.length > 0) {
        $("#modal-announcement").modal("show");
      } else {
        $("#modal-announcement").modal("hide");
      }
    },
    changeShowIndex(plus) {
      console.log(this.showIndex);
      console.log(this.adInformation.length);
      if (this.showIndex === 0 && plus === -1) {
      } else if (
        this.showIndex === this.adInformation.length - 1 &&
        plus === 1
      ) {
      } else {
        this.showIndex = this.showIndex + plus;
      }
    },
    closeModal() {
      if (this.userCheckMaintenance === true) {
        localStorage.setItem("stop-show-maintenance", "true");
      }
      $("#modal-announcement").modal("hide");
    },
  },
};
</script>
<style lang="scss" scoped>
.notice-content {
  background: #dfe7f3;
  width: 100%;
  height: 100%;
}
.maintenance-content {
  background: #ffebb9;
  width: 100%;
  height: 100%;
}

.maintenance-size {
  width: 100px;
  height: 100px;
}
.maintenance-bg {
  width: 140px;
  height: 140px;

  background: rgba(255, 255, 255, 0.6);
}
.notice-bg {
  width: 140px;
  height: 140px;

  background: #32c1db;
}

.notice-height {
  height: 120px;
}

.image-container {
  max-width: 100%;
  height: auto;
}

.image-container img {
  max-width: 100%;
  max-height: 100%;
}
.image-container a {
  max-width: 100%;
  max-height: 100%;
}

.modal-tall {
  position: relative;
  min-height: 600px;
  max-height: 600px;
  padding: 15px;
}
</style>
